import { css } from 'styled-components/macro'
import { resolveResponsiveProp } from 'styles/mixins'

type Space =
    | -24
    | -16
    | -14
    | -12
    | -8
    | -4
    | 0
    | 2
    | 4
    | 6
    | 8
    | 10
    | 11
    | 12
    | 14
    | 16
    | 18
    | 20
    | 22
    | 24
    | 28
    | 30
    | 32
    | 34
    | 36
    | 38
    | 40
    | 42
    | 44
    | 46
    | 48
    | 50
    | 52
    | 54
    | 56
    | 64
    | 70
    | 74
    | 76
    | 80
    | 92
    | 102
    | 112
    | 120
    | 138
    | 198
export type ResponsiveSpace = Space | [Space, Space]

export interface Spacing {
    margin?: ResponsiveSpace
    mt?: ResponsiveSpace
    mr?: ResponsiveSpace
    mb?: ResponsiveSpace
    ml?: ResponsiveSpace
    padding?: ResponsiveSpace
    pt?: ResponsiveSpace
    pr?: ResponsiveSpace
    pb?: ResponsiveSpace
    pl?: ResponsiveSpace
    px?: ResponsiveSpace
    py?: ResponsiveSpace
}

export const spacingMixin = css<Spacing>`
    ${({ margin }) =>
        margin &&
        resolveResponsiveProp({ type: 'margin', value: margin, unit: 'px' })};
    ${({ ml }) =>
        ml &&
        resolveResponsiveProp({ type: 'margin-left', value: ml, unit: 'px' })};
    ${({ mr }) =>
        mr &&
        resolveResponsiveProp({ type: 'margin-right', value: mr, unit: 'px' })};
    ${({ mb }) =>
        mb &&
        resolveResponsiveProp({
            type: 'margin-bottom',
            value: mb,
            unit: 'px',
        })};
    ${({ mt }) =>
        mt &&
        resolveResponsiveProp({ type: 'margin-top', value: mt, unit: 'px' })};
    ${({ padding }) =>
        padding &&
        resolveResponsiveProp({ type: 'padding', value: padding, unit: 'px' })};
    ${({ pl }) =>
        pl &&
        resolveResponsiveProp({ type: 'padding-left', value: pl, unit: 'px' })};
    ${({ pr }) =>
        pr &&
        resolveResponsiveProp({
            type: 'padding-right',
            value: pr,
            unit: 'px',
        })};
    ${({ pb }) =>
        pb &&
        resolveResponsiveProp({
            type: 'padding-bottom',
            value: pb,
            unit: 'px',
        })};
    ${({ pt }) =>
        pt &&
        resolveResponsiveProp({ type: 'padding-top', value: pt, unit: 'px' })};
    ${({ px }: { px?: ResponsiveSpace }) =>
        px &&
        css`
            ${resolveResponsiveProp({
                type: 'padding-left',
                value: px,
                unit: 'px',
            })};
            ${resolveResponsiveProp({
                type: 'padding-right',
                value: px,
                unit: 'px',
            })};
        `};
    ${({ py }: { py?: ResponsiveSpace }) =>
        py &&
        css`
            ${resolveResponsiveProp({
                type: 'padding-top',
                value: py,
                unit: 'px',
            })};
            ${resolveResponsiveProp({
                type: 'padding-bottom',
                value: py,
                unit: 'px',
            })};
        `};
`
